//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconArrowLineRight(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M16.0002 6V18H18.0002V6H16.0002ZM5.66016 6L10.6602 12L5.66016 18H8.2702L13.2702 12L8.2702 6H5.66016Z" fill="currentColor" /></svg>;
}
export default IconArrowLineRight;